import LeftSide from "/components/layouts/leftSide";
import InfoMenu from "../../components/pages/faq/menu";
import { wrapper } from "../../redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import Redis from "/lib/redis";
import { useSelector } from "react-redux";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { sspWrapper } from "../../utils/errors/sspWrapper";

export default function PaymentPage({ scripts, host, isBaltex }) {
  const { content } = useSelector((state) => state.meta);
  return (
    <LayoutWrapper scripts={scripts} host={host} isBaltex={isBaltex}>
      <LeftSide
        isBaltex={isBaltex}
        side={<InfoMenu isBaltex={isBaltex}></InfoMenu>}
        title="Оплата"
      >
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </LeftSide>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ req, query, resolvedUrl }) => {
    store.dispatch(addBreadcrumb({ link: "/payment/", name: "Оплата" }));

    return pagesWrapper(
      { pageType: SITE_PAGE_TYPE.static },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/payment/",
    );
  }),
);
